import * as React from 'react';
import {Box, Card, CardContent, Typography} from "@mui/material";

interface IBusinessProfileProps {
    baseline: any[],
    final: any[],
}

const ImproveCareer = ({baseline, final}: IBusinessProfileProps) => {
    let value = '0'
    const baseCount = baseline.filter((submission: any) => ['BIZ_IDEA_EM_T0', 'BIZ_IDEA_UNEM_T0'].includes(submission.career_status_t0)).length
    const finalCount = final.filter((submission: any) => ['CAREER_T1'].includes(submission.career_status_idea_t1)).length

    if (baseCount > 0) {
        value = (finalCount / baseCount * 100).toFixed()
    }

    return (
        <Card className="chart-container">
            <CardContent className="space-y-4">
                <div className="bold">
                    <Typography variant="h5"  sx={{ fontWeight: 600 }}>
                        Participants didn’t manage to open a business, but they improve their career or find a job
                    </Typography>
                </div>
                <div className="enrolled-item space-x-4">
                    <Box
                        sx={{
                            width: 58,
                            p: 1,
                            border: '1px solid grey',
                            textAlign: 'right',
                            fontSize: '1.25rem',
                            backgroundColor: 'rgb(243, 244, 246)',
                        }}
                    >
                        { value }
                    </Box>
                    <Typography>
                        % of individual that had improved their career
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );
};

export default ImproveCareer;
